// Static mock data for the NRT Mapping Tool UI. This story renders the
// approved design against fixed data only; no API calls are made and no
// create/update/delete/save logic is wired up. See US2044679 for the AC.
// Record/status shapes live in the interface layer (per the repo's page
// library pattern), not here — this file only supplies the fixed data.

import type { NrtRecord } from "@dealer-center/ddc-pages-nrt-database-filter-tool-interface";

export const mockNrtMappingRecords: NrtRecord[] = [
  {
    id: "randomuuid-1697236441",
    caseNumber: "11310301",
    accountId: "bobstoyota",
    providerId: "cvi_smartpath",
    status: "ACTIVE",
    type: "NEW",
    classification: "PRIMARY",
    createdBy: "Jane.Doe",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "",
    select: "make == 'Toyota'",
    map: "msrp = msrp - 5000",
    notes: "Subtract $5000 from MSRP for all new Toyota inventory."
  },
  {
    id: "randomuuid-1697236442",
    caseNumber: "11310302",
    accountId: "smithford",
    providerId: "cvi_smartpath",
    status: "ACTIVE",
    type: "NEW",
    classification: "PRIMARY",
    createdBy: "Jane.Doe",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "discount",
    select: "make == 'Ford'",
    map: "msrp = msrp - 3000",
    notes: "Reduce MSRP by $3000 for new Ford inventory."
  },
  {
    id: "randomuuid-1697236443",
    caseNumber: "11310303",
    accountId: "johnsonhonda",
    providerId: "cvi_homenet",
    status: "ACTIVE",
    type: "USED",
    classification: "ALL",
    createdBy: "Marcus.Lee",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "",
    select: "type == 'Truck'",
    map: "category = 'Trucks'",
    notes: "Group truck body styles into the Trucks category."
  },
  {
    id: "randomuuid-1697236444",
    caseNumber: "11310304",
    accountId: "petersonjeep",
    providerId: "ALL",
    status: "INACTIVE",
    type: "ALL",
    classification: "CLASSIFIEDS",
    createdBy: "Marcus.Lee",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "premium",
    select: "msrp > 50000",
    map: "badge = 'Premium'",
    notes: "Tag premium listings over $50k. Disabled pending review."
  },
  {
    id: "randomuuid-1697236445",
    caseNumber: "11310305",
    accountId: "millerchevy",
    providerId: "cvi_smartpath",
    status: "ACTIVE",
    type: "NEW",
    classification: "PRIMARY",
    createdBy: "Priya.Natarajan",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "family",
    select: "seatingCapacity >= 7",
    map: "category = 'Family'",
    notes: "Tag 7+ seat new vehicles as Family category."
  },
  {
    id: "randomuuid-1697236446",
    caseNumber: "11310306",
    accountId: "davisnissan",
    providerId: "cvi_homenet",
    status: "INACTIVE",
    type: "USED",
    classification: "PRIMARY",
    createdBy: "Priya.Natarajan",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "",
    select: "accidentHistory == true",
    map: "badge = 'Clean Title'",
    notes: "Add Clean Title badge to accident-free used vehicles."
  },
  {
    id: "randomuuid-1697236447",
    caseNumber: "11310307",
    accountId: "wilsonmazda",
    providerId: "cvi_smartpath",
    status: "ACTIVE",
    type: "NEW",
    classification: "ALL",
    createdBy: "Jane.Doe",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "electric",
    select: "engine == 'EV'",
    map: "category = 'Electric'",
    notes: "Categorize EV new inventory as Electric."
  },
  {
    id: "randomuuid-1697236448",
    caseNumber: "11310308",
    accountId: "andersonkia",
    providerId: "cvi_smartpath",
    status: "INACTIVE",
    type: "NEW",
    classification: "ALL",
    createdBy: "Marcus.Lee",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "",
    select: "make == 'Toyota' && model == 'Supra'",
    map: "category = 'Sports Car'",
    notes: "Categorize Supra as Sports Car."
  },
  {
    id: "randomuuid-1697236449",
    caseNumber: "11310309",
    accountId: "garciahyundai",
    providerId: "cvi_homenet",
    status: "TESTING",
    type: "USED",
    classification: "ALL",
    createdBy: "Priya.Natarajan",
    dateCreated: "1762273875",
    expirationDate: "1801899949",
    lastAccessed: "1785899949",
    tags: "",
    select: "mileage < 50000",
    map: "badge = 'Low Mileage'",
    notes: "Testing the Low Mileage badge before a broader rollout."
  }
];
